import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'adm4-side-menu-group-header',
    template: `
    @if (!collapsed) {
      <p>{{text}}</p>
    }
    @if (collapsed) {
      <mat-divider></mat-divider>
    }
    `,
    styleUrls: ['./side-menu-group-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SideMenuGroupHeaderComponent {
  /**
   * The group header to display. Will be shown in all upper case.
   */
  @Input() text: string;

  @Input() collapsed: boolean = false;
}
